<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Supplier"
    item-text="name"
    item-value="id"
    :return-object=false
    :disabled="disabled"
    :rules="rules"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "shopId", "rules"],
  computed: {
    model:{
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    ...mapActions("supplier",["list"]),
    getFittingType() {
      this.list({
        pagination: {itemsPerPage:0},
        rows_per_page: 0,
        search: null,
        filters: {},
      })
        .then(data => {
          this.items = data.suppliers.data;
        });
    }
  }
};
</script>
